import request from 'sb-request'
import { reducers } from 'redux/core'
import { modifyItems as modifyQueueItems } from 'redux/models/queue/actions'

import ratedProductsQuery from './ratedProducts.graphql'
import reviewedProductsQuery from './reviewedProducts.graphql'


const getGQLParams = (userId) => {
  if (!userId) {
    return ''
  }

  if (/^\d+$/.test(userId)) {
    return `(userId: ${userId})`
  }

  return `(personalCode: "${userId}")`
}

const fetch = (userId) =>
  request.post('graphql?name=publicProfile', {
    body: {
      query: `{
        user: publicProfile${getGQLParams(userId)} {
          id
          firstName
          lastName
          gender
          avatar
          registrationDate
          subscription: subscriptionStatus {
            value
            statusText
            subscribed
          }
          stats {
            orders
            queue
            reviews
            ratedProducts
          }
        }
      }`,
    },
    modifyResult: ({ user }) => {
      if (!user) {
        return {
          user: {
            registrationDate: null,
            subscription: {
              statusText: null,
            },
          },
          stats: {
            orders: 0,
            queue: 0,
            reviews: 0,
            ratedProducts: 0,
          },
        }
      }

      const { stats, ...userRest } = user

      return {
        user: userRest,
        stats,
      }
    },
  })
    .then(({ user, stats }) => reducers.view.profilePage.set({ user, stats }))

const fetchQueue = (userId) => {
  reducers.view.profilePage.setQueueFetching(true)

  return request.post('graphql?name=publicQueue', {
    body: {
      query: `{
        queue${getGQLParams(userId)} {
          items {
            year
            month
            status: statusName
            tracking {
              id
              trackingNumber
              trackingUrl
              shipmentDate
              status
            }
            products {
              id
              name
              brand
              image
              index
            }
          }
        }
      }`,
    },
    modifyResult: ({ queue }) => modifyQueueItems(queue),
  })
    .then(({ items }) => reducers.view.profilePage.setQueueItems(items))
}

const fetchReceivedProducts = (userId) => {
  reducers.view.profilePage.setReceivedProductsFetching(true)

  return request.post('graphql?name=productsReceived', {
    body: {
      query: `{
        items: productsReceived${getGQLParams(userId)} {
          id
          url
          name
          brand
          img
          category
          type
          rating
          labels
        }
      }`,
    },
    // TODO OMG backend sends "null" sometimes....
    modifyResult: ({ items }) => (items || []),
  })
    .then((items) => reducers.view.profilePage.setReceivedProducts(items))
}

const fetchReviews = (userId) => {
  reducers.view.profilePage.setReviewsFetching(true)

  return request.post('graphql?name=fetchReviews', {
    body: {
      query: reviewedProductsQuery,
      variables: {
        userId,
      },
    },
    // TODO OMG backend sends "null" sometimes....
    modifyResult: ({ publicProfile }) => {
      if (publicProfile && publicProfile.productReviews) {

        return publicProfile.productReviews.map((review) => {
          const {
            id, date, text, tags, rating, skinType, ageCategory, likes, dislikes,
            product, helpful: { dislikeCount, likeCount, isUseful },
          } = review

          return {
            id,
            date,
            text,
            tags,
            rating,
            product,
            skinType,
            ageCategory,
            likes,
            dislikes,
            likeCount,
            dislikeCount,
            isUseful,
          }
        })
      }

      return []
    },
  })
    .then((items) => reducers.view.profilePage.setReviews(items))
}

const fetchRatedProducts = (userId) => {
  const variables = {}

  if (/^\d+$/.test(userId)) {
    variables.userId = userId
  }
  else {
    variables.personalCode = userId
  }

  reducers.view.profilePage.setRatedProductsFetching(true)

  return request.post('graphql?name=ratedProducts', {
    body: {
      query: ratedProductsQuery,
      variables,
    },
    modifyResult: ({ ratedProducts }) => (ratedProducts.items || []),
  })
    .then((items) => {
      reducers.view.profilePage.setRatedProducts(items)
    })
}


export default {
  fetch,
  fetchQueue,
  fetchReceivedProducts,
  fetchReviews,
  fetchRatedProducts,
}
